/**
 * AdEvents — canonical event names emitted by VastOutstreamPlayer.
 *
 * Pass an AdEventEmitter instance as the `emitter` prop and listen to these
 * constants to integrate your telemetry layer without coupling to the player internals.
 */
export const AdEvents = {
  /** VAST URL / XML was handed to the player and a fetch/parse was kicked off */
  AD_REQUESTED:        'ad:requested',

  /** Media metadata loaded (browser knows duration) */
  LOADED:              'ad:loaded',

  /** First play — equivalent to IMA STARTED */
  STARTED:             'ad:started',

  /** 25 % playback reached — equivalent to IMA FIRST_QUARTILE */
  FIRST_QUARTILE:      'ad:firstQuartile',

  /** 50 % playback reached — equivalent to IMA MIDPOINT */
  MIDPOINT:            'ad:midpoint',

  /** 75 % playback reached — equivalent to IMA THIRD_QUARTILE */
  THIRD_QUARTILE:      'ad:thirdQuartile',

  /** Playback reached 100 % — equivalent to IMA COMPLETE */
  COMPLETE:            'ad:complete',

  /** Video paused by user or visibility logic */
  PAUSED:              'ad:paused',

  /** Video resumed after pause */
  RESUMED:             'ad:resumed',

  /** Audio muted */
  MUTED:               'ad:muted',

  /** Audio unmuted */
  UNMUTED:             'ad:unmuted',

  /** User clicked the Skip button */
  SKIPPED:             'ad:skipped',

  /** User clicked the Close button */
  CLOSED:              'ad:closed',

  /** User clicked the video (click-through) */
  CLICKED:             'ad:clicked',

  /** Browser entered fullscreen */
  FULLSCREEN:          'ad:fullscreen',

  /** Browser exited fullscreen */
  EXIT_FULLSCREEN:     'ad:exitFullscreen',

  /** MRC viewable-impression outcome determined */
  VIEWABLE_IMPRESSION: 'ad:viewableImpression',

  /** Any error (parse, network, playback) */
  ERROR:               'ad:error',
};
